import React from 'react';

export default function ExportSettingsView({ json, onDownload }) {
  return (
    <>
      <textarea readOnly defaultValue={json} rows={10}/>
      <button
        type="button"
        className="btn btn-info btn-sm mt-3 mb-1"
        onClick={onDownload}>
        Download
      </button>
    </>
  );
}
